import * as React from 'react';
import classNames from 'classnames';
import {Flex} from '../Flex';
import {Text} from '../Text';
import style from './avatar.scss';

export interface AvatarProps {
  imageSrc?: string;
  gravatarUrl?: string;
  fallback: string;
  className?: string;
}

export interface AvatarState {
  imageUrl: string;
  showFallback: boolean;
}

export class Avatar extends React.Component<AvatarProps, AvatarState> {
  // This is `any` and not `React.Ref<HTMLImageElement>` because their typing does not include the `complete` attribute
  image?: any;

  constructor(props) {
    super(props);

    this.state = {
      imageUrl: props.imageSrc || props.gravatarUrl,
      showFallback: false,
    };
  }

  handleImageError = () => {
    this.setState({showFallback: true});
  };

  componentDidMount() {
    // If image isn't loaded, let react onError handle it
    if (!this.image.complete) { return; }
    if (this.image.naturalWidth > 0) { return; }

    this.setState({showFallback: true}); // eslint-disable-line react/no-did-mount-set-state
  }

  setImageRef = (ref) => {
    this.image = ref;
  };

  render() {
    const {imageUrl, showFallback} = this.state;
    const {fallback, className} = this.props;

    if (showFallback || !imageUrl) {
      return (
        <Flex
          justifyContent="center"
          alignItems="center"
          className={classNames(style.circle, style.avatarFallback, className)}
        >
          <Text type="h3" text={fallback} style={{marginBottom: 0}} />
        </Flex>
      );
    }

    return (
      <img
        ref={this.setImageRef}
        alt={fallback}
        className={classNames(style.circle, style.avatar, className)}
        srcSet={imageUrl}
        onError={this.handleImageError}
      />
    );
  }
}

export default Avatar;
